import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import DecisionTreeGraph from "./DecisionTreeGraph";
import firebase from "firebase/compat/app";

const Chapter8_5 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question: "Frage 1: ",
      options: [
        {
          value: "A",
          label: "",
        },
        {
          value: "B",
          label: "",
        },
      ],
      correct: "A",
    },
    {
      question: "",
      options: [
        {
          value: "A",
          label: "",
        },
        {
          value: "B",
          label: "",
        },
      ],
      correct: "A",
    },
  ];

  // Firebase Auth Listener verwenden
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); // Benutzer ist eingeloggt, setze userId
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/login"); // Weiterleitung auf die Login-Seite
      }
    });

    // Cleanup function: Den Listener aufräumen, wenn die Komponente entladen wird
    return () => unsubscribe();
  }, [navigate]);

  // Debug: Überprüfe, ob die userId gesetzt ist
  useEffect(() => {
    console.log("Aktuelle userId in 8_5.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    // Firebase Logout Beispiel
    auth
      .signOut()
      .then(() => {
        // Weiterleitung nach dem Logout
        window.location.href = "/login"; // Oder benutze useNavigate von react-router-dom
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        // Überprüfen, ob das Dokument existiert
        const userDoc = await db.collection("users").doc(userId).get();

        console.log("userDoc:", userDoc.exists); // Prüfen, ob das Dokument existiert

        if (userDoc.exists) {
          // Falls das Dokument existiert, aktualisieren
          await db
            .collection("users")
            .doc(userId)
            .update({
              lastChapter: "8_5",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("8_5"),
            });
          console.log("Dokument aktualisiert mit Kapitel 8_5.");
        } else {
          // Falls das Dokument nicht existiert, erstellen
          await db
            .collection("users")
            .doc(userId)
            .set({
              lastChapter: "8_5",
              completedChapters: ["8_5"],
            });
          console.log("Dokument erstellt mit Kapitel 8_5");
        }

        navigate("/course-overview"); // Weiter zur nächsten Seite
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container pb-5">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/course-overview"
                >
                  8: Abschluss
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Cybersecurity Entscheidungsbaum
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>
        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-5">Cybersecurity Entscheidungsbaum</h3>

          <img
            src="/images/baum.svg"
            alt="baum"
            style={{ position: "relative", maxWidth: "15%", height: "auto" }}
          />
        </div>
        <div className="container">
          <p className="col-lg-11 p-5 mx-auto">
            <br />
            Hier hast du hier die Möglichkeit, dein gewonnenes Wissen praktisch
            anzuwenden. In verschiedenen interaktiven Szenarien kannst du
            ausprobieren, wie du auf klassische Herausforderungen reagieren
            würdest.
            <br />
            <br />
            Erlebe praxisnahe Entscheidungen, erhalte direktes Feedback und
            vertiefe dein Verständnis für effektive Cybersecuritysstrategien.
            Los geht’s – teste dein Wissen jetzt!
          </p>
        </div>{" "}
        <DecisionTreeGraph />
        <h3 className="px-5 ">
          Übersicht über Tools und Techniken der Cybersecurity{" "}
        </h3>
        <h4 className="p-5">
          1. Sicherheitsüberwachung und Bedrohungserkennung
        </h4>
        <p className="col-lg-11 text-start mx-auto">
          <ul>
            <li>
              {" "}
              <Link to="/4_3#siem" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                SIEM (Security Information and Event Management)
              </Link>{" "}
              <ul>
                <li>
                  Funktion: Zentrale Sammlung, Analyse und Überwachung von
                  sicherheitsrelevanten Ereignissen und Logs.
                </li>
                <li>Beispiele: Splunk, IBM QRadar, Microsoft Sentinel.</li>
              </ul>
            </li>
            <br />
            <li>
              <Link to="/4_3#ids" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                IDS (Intrusion Detection System)
              </Link>

              <ul>
                <li>
                  Funktion: Erkennt verdächtige Aktivitäten und potenzielle
                  Angriffe, löst Alarme aus.
                </li>
                <li>Beispiele: Snort, Suricata, OSSEC.</li>
              </ul>
            </li>
            <br />
            <li>
              <Link to="/4_3#ips" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                IPS (Intrusion Prevention System)
              </Link>{" "}
              <ul>
                <li>
                  Funktion: Blockiert verdächtige Aktivitäten und Angriffe
                  automatisch in Echtzeit.
                </li>
                <li>
                  Beispiele: Cisco Firepower, Palo Alto Networks, Trend Micro
                  TippingPoint.
                </li>
              </ul>
            </li>
          </ul>{" "}
          <br />
          <br />
        </p>
        <hr></hr>
        <h4 className="p-5">2. Netzwerksicherheit</h4>
        <p className="col-lg-11 text-start mx-auto">
          <ul>
            <li>
              {" "}
              <Link to="/4_3#firewall" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                Firewall
              </Link>
              <ul>
                <li>
                  Funktion: Filtert und kontrolliert den Netzwerkverkehr
                  basierend auf vordefinierten Regeln.
                </li>
                <li>Beispiele: pfSense, Cisco ASA, FortiGate.</li>
              </ul>
            </li>
            <br />
            <li>
              {" "}
              <Link to="/3_5#vpn" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                VPN
              </Link>
              <ul>
                <li>
                  Funktion: Verschlüsselt die Verbindung zwischen Endgerät und
                  Netzwerk, schützt vor Datenüberwachung.
                </li>
                <li>Beispiele: OpenVPN, Cisco AnyConnect, NordVPN Teams.</li>
              </ul>
            </li>
            <br />
            <li>
              {" "}
              <Link to="/6_3#waf" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                WAF (Web Application Firewall)
              </Link>
              <ul>
                <li>
                  Funktion: Schützt Webanwendungen vor Angriffen wie
                  SQL-Injection und Cross-Site Scripting (XSS).
                </li>
                <li>Beispiele: Cloudflare WAF, AWS WAF, Imperva.</li>
              </ul>
            </li>{" "}
            <br />
            <li>
              {" "}
              <Link to="/5_3#nac" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                Network Access Control (NAC)
              </Link>
              <ul>
                <li>
                  Funktion: Kontrolliert den Zugriff auf das Netzwerk, basierend
                  auf Geräten und Benutzeridentitäten.
                </li>
                <li>Beispiele: Cisco ISE, Aruba ClearPass.</li>
              </ul>
            </li>
          </ul>{" "}
          <br />
          <br />
        </p>
        <hr></hr>
        <h4 className="p-5">3. Endgerätesicherheit und Verwaltung</h4>
        <p className="col-lg-11 text-start mx-auto">
          <ul>
            <li>
              {" "}
              <Link to="/5_5#emm" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                EMM (Enterprise Mobility Management)
              </Link>
              <ul>
                <li>
                  Funktion: Verwaltung und Sicherung von mobilen Geräten, Apps
                  und Daten.
                </li>
                <li>Beispiele: VMware Workspace ONE, Microsoft Intune.</li>
              </ul>
            </li>
            <br />
            <li>
              {" "}
              <Link to="/5_5#uem" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                UEM (Unified Endpoint Management)
              </Link>
              <ul>
                <li>
                  Funktion: Zentrale Verwaltung und Sicherheit von Desktop-,
                  Mobil- und IoT-Geräten.
                </li>
                <li>Beispiele: IBM MaaS360, Microsoft Endpoint Manager.</li>
              </ul>
            </li>
            <br />
            <li>
              <Link to="/5_1#edr" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                EDR (Endpoint Detection and Response)
              </Link>

              <ul>
                <li>
                  Funktion: Erkennung, Untersuchung und Reaktion auf Bedrohungen
                  auf Endgeräten.
                </li>
                <li>
                  Beispiele: CrowdStrike Falcon, SentinelOne, Sophos Intercept
                  X.
                </li>
              </ul>
            </li>{" "}
            <br />
            <li>
              <Link to="/3_1#antivirus" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                Antivirus-/Antimalware-Tools
              </Link>

              <ul>
                <li>
                  Funktion: Schutz vor Viren, Malware und anderen schädlichen
                  Programmen.
                </li>
                <li>Beispiele: Bitdefender, Kaspersky, McAfee.</li>
              </ul>
            </li>
          </ul>{" "}
          <br />
          <br />
        </p>
        <hr></hr>
        <h4 className="p-5">4. Risikomanagement und Wiederherstellung</h4>
        <p className="col-lg-11 text-start mx-auto">
          <ul>
            <li>
              <Link to="/4_5#ir" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                Incident Response
              </Link>{" "}
              <ul>
                <li>
                  Funktion: Strukturierte Vorgehensweise zur Erkennung,
                  Eindämmung und Beseitigung von Sicherheitsvorfällen.
                </li>
                <li>
                  Beispiele: ServiceNow Security Operations, IBM Resilient.
                </li>
              </ul>
            </li>
            <br />
            <li>
              <Link to="/4_5#dr" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                Disaster Recovery
              </Link>{" "}
              <ul>
                <li>
                  Funktion: Schnelle Wiederherstellung von IT-Systemen und Daten
                  nach einem Sicherheitsvorfall oder Ausfall.
                </li>
                <li>
                  Beispiele: Veeam Backup & Replication, Acronis Cyber Backup.
                </li>
              </ul>
            </li>
          </ul>{" "}
          <br />
          <br />
        </p>
        <hr></hr>
        <h4 className="p-5">5. Identitäts- und Zugriffsmanagement</h4>
        <p className="col-lg-11 text-start mx-auto">
          <ul>
            <li>
              {" "}
              <Link to="/1_4#iam" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                IAM (Identity and Access Management)
              </Link>{" "}
              <ul>
                <li>
                  Funktion: Verwaltung von Benutzeridentitäten und
                  Zugriffsrechten.
                </li>
                <li>Beispiele: Okta, Microsoft Azure AD, Ping Identity.</li>
              </ul>
            </li>
            <br />
            <li>
              <Link to="/2_3#mfa" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                Multi-Faktor-Authentifizierung (MFA)
              </Link>{" "}
              <ul>
                <li>
                  Funktion: Zusätzliche Sicherheitsebene für
                  Benutzeranmeldungen.
                </li>
                <li>
                  Beispiele: Google Authenticator, Duo Security, RSA SecurID.
                </li>
              </ul>
            </li>
            <br />
            <li>
              <Link to="/4_1#pam" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                Privileged Access Management (PAM)
              </Link>{" "}
              <ul>
                <li>
                  Funktion: Verwaltung und Absicherung von Konten mit
                  erweiterten Rechten.
                </li>
                <li>Beispiele: CyberArk, BeyondTrust, Thycotic.</li>
              </ul>
            </li>
          </ul>{" "}
          <br />
          <br />
        </p>
        <hr></hr>
        <h4 className="p-5">6. Verschlüsselungstechnologien</h4>
        <p className="col-lg-11 text-start mx-auto">
          <ul>
            <li>
              <Link to="/4_2#ssl" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                SSL/TLS (Secure Sockets Layer / Transport Layer Security)
              </Link>{" "}
              <ul>
                <li>
                  Funktion: Verschlüsselung der Kommunikation zwischen Browser
                  und Server.
                </li>
                <li>Beispiele: Let's Encrypt, DigiCert.</li>
              </ul>
            </li>
            <br />
            <li>
              <Link to="/4_4#aes" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                Verschlüsselungsprotokolle (AES, RSA, ECC)
              </Link>{" "}
              <ul>
                <li>Funktion: Schutz von Daten vor unbefugtem Zugriff.</li>
                <li>Beispiele: AES-256 (symmetrisch), RSA (asymmetrisch).</li>
              </ul>
            </li>
          </ul>{" "}
          <br />
          <br />
        </p>
        <hr></hr>
        <h4 className="p-5">7. Schwachstellenmanagement</h4>
        <p className="col-lg-11 text-start mx-auto">
          <ul>
            <li>
              <Link to="/2_1#vulne" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                Vulnerability Scanning (Schwachstellenscanner)
              </Link>{" "}
              <ul>
                <li>
                  Funktion: Identifiziert Sicherheitslücken in Systemen und
                  Anwendungen.
                </li>
                <li>Beispiele: Nessus, OpenVAS, Qualys.</li>
              </ul>
            </li>
            <br />
            <li>
              <Link to="/2_1#patch" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                Patch-Management
              </Link>{" "}
              <ul>
                <li>
                  Funktion: Automatisches Einspielen von Sicherheitsupdates und
                  Patches.
                </li>
                <li>Beispiele: ManageEngine Patch Manager, Microsoft SCCM.</li>
              </ul>
            </li>
          </ul>{" "}
          <br />
          <br />
        </p>
        <hr></hr>
        <h4 className="p-5">8. Threat Intelligence und Analyse</h4>
        <p className="col-lg-11 text-start mx-auto">
          <ul>
            <li>
              <strong>Threat Intelligence Platforms (TIP)</strong>
              <ul>
                <li>
                  Funktion: Analyse und Bewertung von Bedrohungsinformationen.
                </li>
                <li>Beispiele: Recorded Future, ThreatConnect.</li>
              </ul>
            </li>
            <br />
            <li>
              Sandboxing
              <ul>
                <li>
                  Funktion: Verdächtige Dateien werden isoliert und in einer
                  sicheren Umgebung analysiert.
                </li>
                <li>Beispiele: FireEye, Palo Alto WildFire.</li>
              </ul>
            </li>
            <br />
            <li>
              Forensische Tools
              <ul>
                <li>
                  Funktion: Untersuchung und Rekonstruktion von
                  Sicherheitsvorfällen.
                </li>
                <li>Beispiele: EnCase, FTK (Forensic Toolkit).</li>
              </ul>
            </li>
          </ul>{" "}
          <br />
          <br />
        </p>
        <hr></hr>
        <h4 className="p-5">9. Sicherheitsrichtlinien und Compliance</h4>
        <p className="col-lg-11 text-start mx-auto">
          <ul>
            <li>
              <strong>GRC (Governance, Risk, and Compliance)</strong>
              <ul>
                <li>
                  Funktion: Verwaltung von Sicherheitsrichtlinien,
                  Risikobewertung und Einhaltung von Standards.
                </li>
                <li>Beispiele: RSA Archer, ServiceNow GRC.</li>
              </ul>
            </li>
            <br /> <br />
          </ul>{" "}
        </p>
        <hr></hr>
        <h4 className="p-5">10. Sicherheits-Frameworks und Standards</h4>
        <p className="col-lg-11 text-start mx-auto">
          <ul>
            <li>
              ISO 27001: Internationaler Standard für
              Informationssicherheits-Managementsysteme.
            </li>
            <br />
            <li>
              NIST Cybersecurity Framework: Sicherheitsrichtlinien zur
              Risikobewertung und -minderung.
            </li>{" "}
            <br />
            <li>
              PCI DSS: Standards zur Sicherung von Kreditkartendaten.
            </li>{" "}
            <br />
            <li>GDPR (DSGVO): Datenschutz-Grundverordnung der EU.</li>
          </ul>
        </p>
      </div>
    </div>
  );
};

export default Chapter8_5;
